import React, { useCallback } from 'react';

import InventoryForm from '@/components/blocks/inventory/inventory-form';
import { useGlobalState } from '@/contexts/GlobalStateContext';
import type { InventoryCreateSheetProps } from '@/types/module';

const InventoryCreateSheet: React.FC<InventoryCreateSheetProps> = ({
  onProductCreated,
}) => {
  const { state, hideSheet } = useGlobalState();

  // Find the active sheet id for any of the inventory create aliases
  const getActiveSheetId = useCallback(() => {
    const aliases = ['inventory-create', 'create-inventory', 'create-product'];
    // Use the last matching sheet (top-most)
    for (let i = state.sheets.length - 1; i >= 0; i--) {
      const s = state.sheets[i];
      if (aliases.includes(s.type)) return s.id;
    }
    // Fallback to last sheet
    return state.sheets[state.sheets.length - 1]?.id;
  }, [state.sheets]);

  const closeActiveSheet = useCallback(() => {
    const id = getActiveSheetId();
    if (id) hideSheet(id);
  }, [getActiveSheetId, hideSheet]);

  const handleSuccess = useCallback(async () => {
    // Close the global sheet
    closeActiveSheet();
    // Callback to refresh data
    if (onProductCreated) {
      await onProductCreated();
    }
  }, [closeActiveSheet, onProductCreated]);

  const handleCancel = useCallback(() => {
    closeActiveSheet();
  }, [closeActiveSheet]);

  return (
    <div className='py-2'>
      <InventoryForm
        mode='create'
        onSuccess={handleSuccess}
        onCancel={handleCancel}
      />
    </div>
  );
};

export default InventoryCreateSheet;
